/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { isEmpty, isValidEmail } from "../../../utils/validator";
import ValidationError from "../../../components/validation-error-label";
import FullScreenLoader from "../../../components/full-screen-loader";
import { POST } from "../../../config/https";
import APIS from "../../../config/api";
import Iconify from "../../../components/iconify";
import { Typography, Link, InputAdornment, IconButton } from "@mui/material";
import Color from "../../../theme/color";
const formDataType = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  address: "",
  profileImage: null,
  phoneNumber: null,
  accountHolderName: null,
  accountNumber: null,
  ifscCode: null,
  bankName: null,
  companyName: null,
};

export default function SignUpForm() {
  const [formData, setFormData] = useState(formDataType);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isValidation, setIsValidation] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setErrors] = useState("");
  const [signStatus, setSignStatus] = useState(false);

  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [
    formData.firstName,
    formData.lastName,
    formData.email,
    formData.password,
    isValidation,
    error,
  ]);
  useEffect(() => {
    setErrors("");
  }, [formData.email]);

  const onChangeText = (key: string, e: any) => {
    let newData = { ...formData };
    switch (key) {
      case "firstName":
        newData.firstName = e.target.value;
        break;
      case "lastName":
        newData.lastName = e.target.value;
        break;
      case "email":
        newData.email = e.target.value;
        break;
      case "password":
        newData.password = e.target.value;
        break;
    }
    setFormData(newData);
  };
  const toggleForm = () => {
    navigate("/login");
  };
  const clearForm = () => {
    setFormData(formDataType);
  };
  const handleClick = async () => {
    if (!validator()) return;
    setIsValidation(true);
    setLoader(true);
    let param = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      password: formData.password,
      address: "",
      profileImage: formData.profileImage,
      phoneNumber: formData.phoneNumber,
      accountHolderName: formData.accountHolderName,
      accountNumber: formData.accountNumber,
      ifscCode: formData.ifscCode,
      bankName: formData.bankName,
      companyName: formData.companyName,
    };
    await POST(APIS.ADD_USER, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          setSignStatus(true);
          clearForm();
          setIsValidation(false);
          setErrors("");
          setFormErrors({});
        } else {
          const errorMessage = res.errors[0].toString();
          setErrors(errorMessage);
          validator();
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
        validator();
      });
  };
  const validator = () => {
    const errors: Record<string, string> = {};
    if (isEmpty(formData.firstName)) {
      errors.firstName = "Please enter a First name";
    }
    if (isEmpty(formData.email)) {
      errors.email = "Please enter an email";
    } else if (!isValidEmail(formData.email)) {
      errors.email = "Please enter a valid email";
    } else if (error) {
      errors.email = error;
    } else {
      delete errors.email;
    }
    if (isEmpty(formData.password)) {
      errors.password = "Please enter a password";
    } else {
      if (formData.password.length < 6) {
        errors.password = "Password should contain minimum 6 characters";
      } else if (!/[A-Z]/.test(formData.password)) {
        errors.password = "Password must contain at least one uppercase letter";
      } else if (!/[a-z]/.test(formData.password)) {
        errors.password = "Password must contain at least one lowercase letter";
      } else if (!/\d/.test(formData.password)) {
        errors.password =
          "Password must contain at least one numeric character";
      } else if (!/[^a-zA-Z0-9]/.test(formData.password)) {
        errors.password =
          "Password must contain at least one non-alphanumeric character";
      }
    }
    if (isEmpty(formData.lastName)) {
      errors.lastName = "Please enter a Last name";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleClick();
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            onKeyPress={(e) => {
              const pattern = /[0-9]/;
              if (pattern.test(e.key)) {
                e.preventDefault();
              }
            }}
            value={formData.firstName}
            type="text"
            fullWidth
            label="First Name *"
            autoFocus
            onChange={(e) => onChangeText("firstName", e)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <ValidationError formErrors={formErrors.firstName || ""} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            onKeyPress={(e) => {
              const pattern = /[0-9]/;
              if (pattern.test(e.key)) {
                e.preventDefault();
              }
            }}
            value={formData.lastName || ""}
            type="text"
            fullWidth
            label="Last Name *"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => onChangeText("lastName", e)}
          />
          <ValidationError formErrors={formErrors.lastName} />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={formData.email || ""}
            onKeyPress={handleKeyPress}
            type="email"
            fullWidth
            label="Email Address *"
            onChange={(e) => onChangeText("email", e)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <ValidationError formErrors={formErrors.email} />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={formData.password || ""}
            onKeyPress={handleKeyPress}
            fullWidth
            label="Password *"
            type={showPassword ? "text" : "password"}
            onChange={(e) => onChangeText("password", e)}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    <Iconify
                      icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <ValidationError formErrors={formErrors.password} />
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>

      <Typography variant="body2" sx={{ mb: 2 }}>
        <Link
          style={{
            textDecoration: "none",
            fontSize: "15px",
          }}
          onClick={toggleForm}
          variant="subtitle2"
          underline="hover"
          component="button"
        >
          Sign In
        </Link>
      </Typography>
      {signStatus ? (
        <Typography
          sx={{ paddingBottom: "5px" }}
          style={styles.validationError}
        >
          Sign Up Successful. Please click on Sign In to login
        </Typography>
      ) : (
        ""
      )}

      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        style={{ backgroundColor: Color.primary, fontSize: "17px" }}
        onClick={handleClick}
      >
        Sign Up
      </LoadingButton>
      <FullScreenLoader open={loader} />
    </>
  );
}
const styles = {
  validationError: {
    marginTop: 1,
    marginBottom: 1,
    color: "Green",
    width: "100%",
    fontSize: "16px",
    fontWeight: "bold",
  },
};
